// @flow

// Vendors
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

// Components
import { FormActions, FormActionsItem, Trans } from '../..';
import { Modal } from '../../modals';
import { TxAlert, TxAlertType, TxButton, TxButtonMode } from 'texkit-ui/components';

// Actions
import { closeModal } from '../../../../reducers/modal/modalActions';
import { submitDeactivation } from '../../../../reducers/accountRecovery/accountRecoveryActions';

// Helpers
import { bodyHasError } from '../../../../lib/validation';

// Styles
import './deactivation-speedbump-modal.scss';

const MODAL_ID = 'DeactivationSpeedbumpModal/AccountRecoveryPage';

const DeactivationSpeedbumpModal = () => {
  const dispatch = useDispatch();
  const [isSubmitting, setSubmitting] = useState(false);
  const [showError, setShowError] = useState(false);

  function handleCancel() {
    dispatch(closeModal(MODAL_ID));
  }

  function handleClose() {
    setShowError(false);
  }

  async function handleDeactivate() {
    setSubmitting(true);
    try {
      await dispatch(submitDeactivation());
      dispatch(closeModal(MODAL_ID));
    } catch (error) {
      if (bodyHasError(error?.body, { exactError: 'MGMW_EX_0002' })) {
        setShowError(true);
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal name={MODAL_ID} className="deactivation-speedbump-modal" onClose={handleClose}>
      <h2 className="h1 modal-title">
        <Trans
          file="AccountRecovery"
          id="DeactivationSpeedbumpTitle"
          fallback="Are you sure you want to deactivate your account?"
        />
      </h2>
      <div className="modal-content">
        <p>
          <Trans
            file="AccountRecovery"
            id="DeactivationSpeedbumpBody"
            fallback="All your data will be deleted except account name and transaction history. Please create a new account in order to use TxT."
          />
        </p>
      </div>
      {showError && (
        <TxAlert
          type={TxAlertType.Error}
          heading={
            <Trans
              file="Errors"
              id="Exception_Link_Title"
              fallback="Something went wrong"
            />
          }
        >
          <Trans
            file="Errors"
            id="Exception_Link"
            fallback="Please try again later."
          />
        </TxAlert>
      )}
      <FormActions align="center">
        <FormActionsItem>
          <TxButton
            mode={TxButtonMode.Danger}
            type="button"
            onClick={handleDeactivate}
            isLoading={isSubmitting}
            loadingContent={
              <Trans file="Labels" id="Deactivating" fallback="Deactivating" />
            }
          >
            <Trans
              file="Labels"
              id="DeactivateAccount"
              fallback="Yes, deactivate"
            />
          </TxButton>
        </FormActionsItem>
        <FormActionsItem>
          <TxButton
            mode={TxButtonMode.Secondary}
            type="button"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            <Trans file="Labels" id="No_Cancel" fallback="No, cancel" />
          </TxButton>
        </FormActionsItem>
      </FormActions>
    </Modal>
  );
};

export default DeactivationSpeedbumpModal;